<template>
  <WdsModal
    ref="block-modal"
    :show="show"
    :z-index="4000"
    :title="$t('Decline and block Trusted Contact')"
    @cancel="close"
  >
    <template #default>
      <WdsAlert v-if="errorBannerMessage" error class="m-b-15">{{ errorBannerMessage }}</WdsAlert>

      {{ $t('Are you sure you want to block this trusted contact?') }}
    </template>

    <template #footer>
      <WdsStack justify-space-between>
        <WdsButton tertiary data-test="tc-block-cancel" @click="close">
          {{ $t('Cancel') }}
        </WdsButton>

        <WdsStack align-center gap-md>
          <WdsSpinner v-if="loading" indeterminate />

          <WdsButton
            error
            :disabled="loading"
            data-test="tc-block-confirm"
            @click="blockTrustedContact"
          >
            {{ $t('Block') }}
          </WdsButton>
        </WdsStack>
      </WdsStack>
    </template>
  </WdsModal>
</template>

<script setup lang="ts">
import gql from 'graphql-tag'
import { ref } from 'vue'
import { WdsAlert, WdsModal, WdsStack, WdsSpinner, WdsButton } from '@worksome/wds-components'
import { publicApi } from '@/app-bootstrapping/SetUpApollo'
import { FormValidation } from '@/utils/formValidation'
import { $t } from '@/composables/translation'

const props = defineProps({
  trustedContactId: {
    type: String,
    required: true,
  },
  show: {
    type: Boolean,
    required: true,
  },
})

const emit = defineEmits(['cancel', 'close', 'deleted'])

const loading = ref(false)
const errorBannerMessage = ref(null)

const close = () => {
  emit('cancel')

  errorBannerMessage.value = null
}

const blockTrustedContact = async () => {
  loading.value = true

  await publicApi
    .mutate({
      mutation: gql`
        mutation BlockTrustedContact($input: BlockTrustedContactInput!) {
          blockTrustedContact(input: $input) {
            id
          }
        }
      `,
      variables: {
        input: {
          id: props.trustedContactId,
          account: currentAccount.globalId,
        },
      },
    })
    .then(() => {
      emit('close')
      emit('deleted')

      errorBannerMessage.value = null
    })
    .catch((error) => {
      const { graphQLErrors } = error

      if (FormValidation.containsErrorMessage(graphQLErrors)) {
        errorBannerMessage.value = graphQLErrors[0].message
      } else {
        errorBannerMessage.value = $t('An error occurred')
      }
    })
    .finally(() => {
      loading.value = false
    })
}
</script>
